import ListOut from '@components/shared/ListOut'
import Chat from '@components/chat/components/ListItemChat'
import useGradualFetch from '@hooks/useGradualFetch'
import SpinnerBlock from '@components/spinner/SpinnerBlock'
import Empty from '@components/shared/Empty'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import { apiFetcherProtected } from '@api/apiFetcher'

import styles from '@components/chat/styles/ChatList.module.css'

const API_USER_CHATS = '/api/chat/chats/user/:skip/:limit'
const API_SYSTEM_CHATS = '/api/chat/chats/system/:skip/:limit'
const PER_PAGE = 10

const ListChats = ({ user, openChat,
        highlightedContact, listUserChats }) => { // <- listSystemChats is available here

    const userId = user?._id
    const endpoint = listUserChats
        ? API_USER_CHATS + contact(highlightedContact)
        : API_SYSTEM_CHATS

    const [chats, loading, button] = useGradualFetch(endpoint,
        apiFetcherProtected(user?.token), PER_PAGE)

    const nomessages = useT('Nie masz wiadomości')

    if (chats.length < 1 && loading) return <SpinnerBlock height={400} />

    return <div className={styles.list}>
        { chats.length > 0
            ? <ListOut id="_id" items={chats} Component={Chat}
                open={openChat} userId={userId} />

            : <Empty text={<><Icon>mail_outline</Icon> {nomessages}.</>} /> }

        {button}
    </div>
}

function contact (highlightedContact) {
    return highlightedContact
        ? `?filter=${highlightedContact}`
        : ''
}

export default ListChats